import styles from "./TimeSlot.module.scss";

import { useCallback, useMemo } from "react";

import { formatInTimeZone } from "date-fns-tz";

type TimeSlotProps = {
  slot: string;
  timezone: string;
  onSelected?: (label: string) => void;
};

export function TimeSlot({ slot, timezone, onSelected }: TimeSlotProps) {
  const handleOnSelected = useCallback(() => {
    onSelected?.(slot);
  }, [onSelected, slot]);

  const label = useMemo(() => {
    return formatInTimeZone(new Date(slot), timezone, "hh:mma").toLowerCase();
  }, [slot, timezone]);

  return (
    <div className={styles.container}>
      <div
        data-testid={`${slot}-slot`}
        className={styles.slot}
        onClick={handleOnSelected}
      >
        <span className={styles.label}>{label}</span>
      </div>
    </div>
  );
}
